import menu from "../../assets/menuimg.jpeg";
import { Breakfast}  from "./Breakfast";
import { Desserts } from "./Desserts";
import  {Dinner}  from "./Dinner";
import  {Drinks}  from "./Drinks";
import { Lunch } from "./Lunch";

const MenuScreen = () =>{
    return(
        <>
            <div>
               <div>
                    <img
                        src={menu}
                        alt="menus"
                         className=" w-full h-[25vh] sm:h-[30vh] lg:h-[40vh] object-cover object-center"/>

                     <Breakfast />  
                     <Lunch />
                     <Dinner />
                     <Desserts />  
                     <Drinks />
                </div>

            </div>
        </>
    );
};

export default MenuScreen;